/**
 * @description 全局Model commentModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import {
  APIS,
  ParamscommentsArticleArticleIdCommentsUsingGet,
  ParamsBodycommentsUsingPost,
  CommentInfo,
  CommonResult
} from '@src/services';
import { TkitUtils as Utils } from '@tkit/types';
import { message } from 'antd';

export interface State {
  commentModel: CommentInfo[];
}

export const commentModelState: State = {
  commentModel: []
};

const model = createModel({
  state: commentModelState,
  namespace: 'commentModel',
  reducers: {
    /**
     * @description 设置评论列表
     */
    setCommentList: (state, action: Tction<CommentInfo[]>) => {
      return {
        ...state,
        commentModel: action.payload
      };
    },
    /**
     * @description 设置删除评论的数据
     */
    setRemoveComment: (state, action: Tction<number>) => {
      const { commentModel } = state;

      return {
        ...state,
        commentModel: commentModel.filter(item => item.id !== action.payload)
      };
    },
    /**
     * @description 设置点赞/取消点赞评论的数据
     */
    setToggleThumb: (state, action: Tction<{ id: number; isThumb: boolean }>) => {
      const { id, isThumb } = action.payload;
      const { commentModel } = state;

      for (const item of commentModel) {
        if (item.id === id) {
          item.hasLiked = isThumb;
          item.thumbs = (item.thumbs || 0) + (isThumb ? 1 : -1);
        }
      }

      return {
        ...state,
        commentModel: [...commentModel]
      };
    },
    /**
     * @description 添加评论
     */
    addCommentReducer: (state, action: Tction<CommentInfo>) => {
      const { commentModel } = state;

      return {
        ...state,
        commentModel: [action.payload, ...commentModel]
      };
    }
  },
  effects: {
    /**
     * 获取文章评论
     */
    *getCommentListAsync(
      { tPut, tCall },
      action: Tction<{
        params: ParamscommentsArticleArticleIdCommentsUsingGet;
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsArticleArticleIdCommentsUsingGet> = yield tCall(
        APIS.CommentApi.commentsArticleArticleIdCommentsUsingGet,
        params
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.setCommentList, res.result);
      }
    },
    /**
     * 获取删除评论
     */
    *removeCommentAsync(
      { tPut, tCall },
      action: Tction<{
        params: { id: number };
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsIdUsingDelete> = yield tCall(
        APIS.CommentApi.commentsIdUsingDelete,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.setRemoveComment, params.id);
        callback && callback();
      }
    },
    /**
     * 点赞
     */
    *thumbAsync(
      { tPut, tCall },
      action: Tction<{
        params: { id: number };
        callback?: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsThumbUpIdUsingPost> = yield tCall(
        APIS.CommentApi.commentsThumbUpIdUsingPost,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.setToggleThumb, { id: params.id, isThumb: true });
        callback && callback(res);
      }
    },
    /**
     * 取消点赞
     */
    *cancelThumbAsync(
      { tPut, tCall },
      action: Tction<{
        params: { id: number };
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsThumbUpIdUsingDelete> = yield tCall(
        APIS.CommentApi.commentsThumbUpIdUsingDelete,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.setToggleThumb, { id: params.id, isThumb: false });
        callback && callback();
      }
    },
    /**
     * 发布1级评论
     */
    *addCommentAynsc(
      { tPut, tCall },
      action: Tction<{
        params: ParamsBodycommentsUsingPost;
        callback: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsUsingPost> = yield tCall(
        APIS.CommentApi.commentsUsingPost,
        params
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.addCommentReducer, res.result);
        callback && callback(res);
      } else {
        message.error(res.message);
      }
    }
  }
});

export default model;
